<template>
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size:18px">15楼</span>
      </div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="deviceName" align="center" label="设备名称"></el-table-column>
        <el-table-column prop="userAdd" align="center" label="安装地址"></el-table-column>
        <el-table-column prop="date" align="center" label="安装日期"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <span slot="title" class="dialog-title">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleChange"
          size="small"
          align="right">
        </el-date-picker>
      </span>
      <el-descriptions :title="detailData.deviceName" direction="vertical" :column="2" border>
        <el-descriptions-item label="设备号">
          <el-tag>{{ detailData.imei }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="设备类型">
          <el-tag size="small">{{ detailData.deviceType }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="在线状态">
          <el-tag type="success" size="small" v-if="detailData.onlineFlag==='在线'">{{ detailData.onlineFlag }}</el-tag>
          <el-tag type="danger" size="small" v-if="detailData.onlineFlag==='掉线'">{{ detailData.onlineFlag }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="口径">
          <el-tag size="small">{{ detailData.caliber }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="设备地址">{{ detailData.userAdd }}</el-descriptions-item>
        <el-descriptions-item label="水表底数(m³)"> {{ detailData.maniFest }}</el-descriptions-item>
        <el-descriptions-item label="最近24小时用量(m³)"> {{ detailData.hourUsages }}</el-descriptions-item>
        <el-descriptions-item label="最近7日用水均值(m³)"> {{ detailData.sevenDayUsages }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      timeRange: [],
      tableData: [
        {
          date: "2025-05-02 09:23:09",
          imei: "2326261616161",
          deviceType: "智能水表",
          onlineFlag: "在线",
          caliber: "DN100",
          maniFest: "456.00",
          hourUsages: "1.00",
          sevenDayUsages: "14.00",
          deviceName: "总表",
          userAdd: "1号电梯口对面"
        },
        {
          date: "2025-05-02 11:53:55",
          imei: "2326261616161",
          deviceType: "智能水表",
          onlineFlag: "在线",
          caliber: "DN100",
          maniFest: "456.00",
          hourUsages: "1.00",
          sevenDayUsages: "14.00",
          deviceName: "水表1",
          userAdd: "休息室"
        },
        {
          date: "2025-05-02 12:20:00",
          imei: "2326261616161",
          deviceType: "智能水表",
          onlineFlag: "在线",
          caliber: "DN100",
          maniFest: "456.00",
          hourUsages: "1.00",
          sevenDayUsages: "14.00",
          deviceName: "水表2",
          userAdd: "卫生间男"
        },
        {
          date: "2025-05-02 14:13:21",
          imei: "2326261616161",
          deviceType: "智能水表",
          onlineFlag: "在线",
          caliber: "DN100",
          maniFest: "456.00",
          hourUsages: "1.00",
          sevenDayUsages: "14.00",
          deviceName: "水表3",
          userAdd: "卫生间女"
        },
      ],
      detailData: {},
      dialogVisible: false,
    };
  },
  methods: {
    handleDetail(row) {
      this.dialogVisible = true;
      this.detailData = row;
    },
    handleClose() {
      this.dialogVisible = false;
      this.detailData = {};
      this.timeRange = [];
    },
    handleChange(e) {
      console.log(e);
    }
  }
};
</script>
<style>
.content {
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
}
.clearfix {
  font-weight: 600;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/asdevice/index.vue